<template>
  <div class="gs-app gm-custom-field-editor gs-refresh-controls flex flex-col w-full" style="max-height: calc(-150px + 100vh)">
    <VuePerfectScrollbar>
      <div class="gm-custom-field-editor__body scroll-modal">
        <div class="p-6">
          <div
            class="flex flex-col mb-6"
            :class="{ 'cursor-not-allowed': type === 'edit' }"
            :title="
              type === 'edit'
                ? $t('frontend_groovemail_forms_step1_field_type_cant_be_edited')
                : ''
            "
          >
            <label class="font-semibold text-sm text-grey-700 mb-2">
              {{ $t('frontend_groovemail_customfields_index_type') }}
            </label>
            <treeselect
              class="h-10 custom-treeselect"
              :class="{
                'pointer-events-none text-sm rounded-lg w-full disabled-treeselect opacity-50': type === 'edit',
              }"
              :disabled="type === 'edit'"
              v-model="input_currentTab"
              :multiple="false"
              :options="customFieldOptions"
              :closeOnSelect="closeOnSelect"
              :clearOnSelect="clearOnSelect"
              :clearable="clearable"
              :placeholder="$t('frontend_groovemail_contacts_step2_select_field')"
            />
          </div>
          <div
            class="relative flex flex-col mb-6"
            :class="{ 'w-full cursor-not-allowed': type === 'edit' }"
            :title="
              type === 'edit'
                ? $t('frontend_groovemail_forms_step1_field_identifier_cant_be_edited')
                : ''
            "
          >
            <label class="font-semibold text-sm text-grey-700 mb-2">
              {{ $t('frontend_groovemail_customfields_index_field_identifier') }}
            </label>
            <text-input
              :class="{
                'pointer-events-none bg-grey-500': type === 'edit',
              }"
              variant="base"
              :disabled="type === 'edit'"
              v-model="model.identifier"
              :placeholder="$t('frontend_groovemail_forms_enter_field_identifier')"
              :validator="$v.model.identifier"
            />
            <div
              v-if="customFieldFormSubmitted && identifierInValid"
              class="text-danger text-sm absolute identifier-error mt-2"
            >
              {{ $t('frontend_groovemail_customfields_index_identifier') }}
            </div>
          </div>

          <div v-if="input_currentTab === 'dropdown'">
            <div class="mb-6">
              <p class="text-grey-700 text-sm font-semibold mb-2">
                {{ $t('frontend_groovemail_customfields_index_field_label') }}
              </p>
              <text-input
                variant="base"
                v-model="model.fieldlabel"
                :placeholder="$t('frontend_groovemail_forms_enter_label')"
                :validator="$v.model.fieldlabel"
              />
            </div>
            <div class="flex items-end mb-2">
              <div class="flex-1">
                <p class="text-grey-700 text-sm font-semibold mb-2">
                  {{ $t('frontend_groovemail_customfields_index_field_option') }}
                </p>
                <text-input
                  variant="base"
                  v-model="model.fieldoption"
                  :placeholder="$t('frontend_groovemail_forms_enter_values')"
                />
              </div>
              <gs-button
                variant="outline"
                size="md"
                class="h-10 px-4 ml-4"
                :disabled="model.fieldoption != '' ? false : true"
                @click="model.fieldoption != '' ? addoption() : null"
              >
                {{ $t('frontend_add') }}
              </gs-button>
            </div>
            <div
              v-if="
                customFieldFormSubmitted &&
                model.mandatory &&
                !model.fieldoptions.length
              "
              class="text-danger text-sm mt-2"
            >
              {{ $t('frontend_groovemail_forms_add_option_for_custom_field') }}
            </div>
            <div class="flex items-center mb-6">
              <gd-checkbox
                :value="model.mandatory"
                :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                labelClass="font-semibold text-sm"
                size="sm"
                variant="primary"
                @change="hasMandatory"
              />
            </div>
          </div>
          
          <div v-if="input_currentTab === 'radio'">
            <div class="mb-6">
              <p class="text-grey-700 text-sm font-semibold mb-2">
                {{ $t('frontend_groovemail_customfields_index_field_label') }}
              </p>
              <text-input
                variant="base"
                v-model="model.fieldlabel"
                :placeholder="$t('frontend_groovemail_forms_enter_label')"
                :validator="$v.model.fieldlabel"
              />
            </div>
            <div class="flex items-end mb-2">
              <div class="flex-1">
                <p class="text-grey-700 text-sm font-semibold mb-2">
                  {{ $t('frontend_groovemail_customfields_index_field_option') }}
                </p>
                <text-input
                  variant="base"
                  v-model="model.fieldoption"
                  :placeholder="$t('frontend_groovemail_forms_enter_values')"
                />
              </div>
              <gs-button
                variant="outline"
                size="md"
                class="h-10 px-4 ml-4"
                :disabled="model.fieldoption != '' ? false : true"
                @click="model.fieldoption != '' ? addoption() : null"
              >
                {{ $t('frontend_add') }}
              </gs-button>
            </div>
            <div
              v-if="
                customFieldFormSubmitted &&
                model.mandatory &&
                !model.fieldoptions.length
              "
              class="text-danger text-sm mt-2"
            >
              {{ $t('frontend_groovemail_forms_add_option_for_custom_field') }}
            </div>
            <div class="flex items-center mb-6">
              <gd-checkbox
                :value="model.mandatory"
                :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                labelClass="font-semibold text-sm"
                size="sm"
                variant="primary"
                @change="hasMandatory"
              />
            </div>
          </div>
          
          <div v-if="input_currentTab === 'checkbox'">
            <div class="mb-6">
              <p class="text-grey-700 text-sm font-semibold mb-2">
                {{ $t('frontend_groovemail_customfields_index_field_label') }}
              </p>
              <text-input
                variant="base"
                v-model="model.fieldlabel"
                :placeholder="$t('frontend_groovemail_forms_enter_label')"
                :validator="$v.model.fieldlabel"
              />
            </div>
            <div class="flex items-end mb-2">
              <div class="flex-1">
                <p class="text-grey-700 text-sm font-semibold mb-2">
                  {{ $t('frontend_groovemail_customfields_index_field_option') }}
                </p>
                <text-input
                  v-model="model.fieldoption"
                  :placeholder="$t('Text')"
                />
                <text-input
                  class="mt-2"
                  variant="base"
                  v-model="model.fieldoptionlink"
                  :placeholder="$t('frontend_groovemail_email_link_optional')"
                />
              </div>
              <gs-button
                variant="outline"
                size="md"
                class="h-10 px-4 ml-4"
                :disabled="model.fieldoption != '' ? false : true"
                @click="model.fieldoption != '' ? addoption() : null"
              >
                {{ $t('frontend_add') }}
              </gs-button>
            </div>
            <div
              v-if="
                customFieldFormSubmitted &&
                model.mandatory &&
                !model.fieldoptions.length
              "
              class="text-danger text-sm mt-2"
            >
              {{ $t('frontend_groovemail_forms_add_option_for_custom_field') }}
            </div>
            <div class="flex items-center mb-6">
              <gd-checkbox
                :value="model.mandatory"
                :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                labelClass="font-semibold text-sm"
                size="sm"
                variant="primary"
                @change="hasMandatory"
              />
            </div>
          </div>
          
          <div v-if="input_currentTab === 'textbox' || input_currentTab === 'datepicker'">
            <div class="mb-6">
              <p class="text-grey-700 text-sm font-semibold mb-2">
                {{ $t('frontend_groovemail_customfields_index_field_default') }}
              </p>
              <text-input
                variant="base"
                v-model="model.fieldtext"
                :placeholder="$t('frontend_groovemail_forms_enter_placeholder_text')"
                :validator="$v.model.fieldtext"
              />
            </div>
            <div class="flex items-center mb-6">
              <gd-checkbox
                :value="model.mandatory"
                :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                labelClass="font-semibold text-sm"
                size="sm"
                variant="primary"
                @change="hasMandatory"
              />
            </div>
          </div>

          <div v-if="input_currentTab === 'textarea'">
            <div class="mb-2">
              <p class="text-grey-700 text-sm font-semibold mb-2">
                {{ $t('frontend_groovemail_customfields_index_field_default') }}
              </p>
              <text-area
                variant="base"
                v-model="model.fieldtext"
                :validator="$v.model.fieldtext"
                :placeholder="$t('frontend_groovemail_forms_enter_placeholder_text')"
              />
            </div>
            <div class="flex items-center mb-6">
              <gd-checkbox
                :value="model.mandatory"
                :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                labelClass="font-semibold text-sm"
                size="sm"
                variant="primary"
                @change="hasMandatory"
              />
            </div>
          </div>
            <div class="w-full">
              <div>
                <div class="mb-4">
                  <p class="text-sm font-semibold mb-2">
                    {{`${ $t('frontend_icon') } ${ $t('frontend_groovemail_customfields_index_field_default') }`}}
                  </p>
                  <font-awesome-picker
                      v-model="model.icon"
                  ></font-awesome-picker>
                </div>
              </div>
            </div>
          <div
            class="mb-6 text-sm bg-white border border-grey-300 btn-radius"
            style="box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05)"
            v-if="this.model.fieldoptions.length > 0"
          >
            <div
              class="px-5 py-3 font-bold text-sm flex justify-between"
              style="border-bottom: 2px solid #dcdcea"
            >
              <div>
                {{ $t('frontend_groovemail_customfields_index_options') }}
              </div>
              <div>
                {{ $t('frontend_groovemail_customfields_index_actions') }}
              </div>
            </div>
            <div class="custom-field-options">
              <div
                class="px-5 py-2 flex items-center justify-between"
                v-for="(option, index) in this.model.fieldoptions"
                :key="index"
              >
                <div v-if="typeof option == 'string'">
                  {{ option}}
                </div>
                <div v-else>
                  {{ option.text }} <br/>
                  {{`${$t('frontend_link')}: ${option.link}`}}
                </div>
                <gs-button
                  variant="ghost"
                  size="icon"
                  class="mr-2 is-destructive"
                  aria-label="Delete custom field option"
                  @click="deleteoption(option)"
                >
                  <DeleteIcon class="h-4 w-4"/>
                </gs-button>
              </div>
            </div>
          </div>

          <div
            class="relative flex flex-col mb-6 w-full"
            v-if="!(type === 'edit' && from === 'forms')"
          >
            <label class="flex items-center font-semibold text-sm text-grey-700 mb-2">
              {{ $t('frontend_groovemail_custom_fields_default_field_label') }}
              <button
                class="ml-1"
                v-tooltip="{
                  content: $t('frontend_groovemail_form_fields_fallback_value_desc'),
                  placement: 'right-start',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  offset: 10,
                  delay: {
                    show: 200,
                    hide: 300,
                  },
                }"
              >
                <InfoIcon class="text-grey-600 h-4 w-4 hover:text-primary"/>
              </button>
            </label>
            <text-input
              variant="base"
              v-model="model.defaultValue"
              :placeholder="$t('frontend_groovemail_custom_fields_default_field_enter_value')"
            />
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
    <div class="flex justify-end px-6 py-4">
      <gs-button
        variant="outline"
        size="md"
        @click="type === 'add' ? closeAddFieldModal() : closeEditFieldModal()"
      >
        {{ $t('frontend_cancel') }}
      </gs-button>
      <gs-button
        variant="primary"
        size="md"
        class="ml-2"
        @click="type === 'add' ? saveCustomField() : updateCustomField()"
      >
        {{ type === 'add' ? $t('frontend_save') : $t('frontend_update') }}
      </gs-button>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import FontAwesomePicker from '@groovepages/gd-ui-kit/components/FontAwesomePicker.vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import showAlert from '@/components/sweet-alert-popup.js';
import Customfield from '@/models/Customfield';
import themeConfig from '@/theme/themeConfig';

// import icons
import InfoIcon from '@/assets/images/icons/new/info_new.svg';
import DeleteIcon from '@/assets/images/icons/new/trash_new.svg';

export default {
  name: 'CreateUpdateField',
  props: {
    type: {
      required: true,
    },
    from: {
      required: true,
    },
    customfieldData: {
      required: true,
    },
  },

  data() {
    return {
      customFieldFormSubmitted: false,
      identifierInValid: false,
      input_currentTab: 'dropdown',
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      model: {
        identifier: '',
        fieldlabel: '',
        fieldtext: '',
        fieldoption: '',
        fieldoptionlink: '',
        fieldoptions: [],
        icon: '',
        mandatory: 0,
        defaultValue: '',
      },
      standardFieldIdentifiers: [
        'email',
        'first_name',
        'last_name',
        'address_1',
        'company',
        'phone_number',
        'state',
        'country',
        'zip',
        'accept',
        'url',
      ],
    };
  },

  methods: {
    initalizeAllFields() {
      this.customFieldFormSubmitted = false;
      this.model = {
        identifier: '',
        fieldlabel: '',
        fieldtext: '',
        fieldoption: '',
        fieldoptionlink: '',
        fieldoptions: [],
        icon: '',
        mandatory: 0,
        defaultValue: '',
      };
      this.$v.model.identifier.$reset();
      this.$v.model.fieldlabel.$reset();
      this.$v.model.fieldtext.$reset();
    },

    closeAddFieldModal() {
      this.$emit('closeCreateFieldModal');
      this.initalizeAllFields();
    },

    closeEditFieldModal() {
      this.$emit('closeEditFieldModal');
      this.initalizeAllFields();
    },

    hasMandatory() {
      this.model.mandatory = !this.model.mandatory;
    },

    addoption() {
      if(this.model.fieldoptionlink === ''){
        this.model.fieldoptions.push(this.model.fieldoption);
      }else{
        this.model.fieldoptions.push({
          text: this.model.fieldoption, 
          link: this.model.fieldoptionlink
        });
      }
      this.model.fieldoption = '';
      this.model.fieldoptionlink = '';
    },

    deleteoption(option) {
      const index = this.model.fieldoptions.indexOf(option);
      if (index > -1) {
        this.model.fieldoptions.splice(index, 1);
      }
    },

    checkIdentifierIsUnique(identifier) {
      return this.standardFieldIdentifiers.includes(identifier);
    },

    async saveCustomField() { 
      this.customFieldFormSubmitted = true;
      if (this.identifierInValid) {
        return true;
      }
      const identifierUnique = this.checkIdentifierIsUnique(
        this.model.identifier
      );
      if (identifierUnique) {
        await showAlert({
          iconType: 'alert-error',
          html: `
            <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
            <p class="text-sm text-deep-dark"> ${this.$t('frontend_groovemail_forms_step1_select_a_unique_identifier')}</p>
          `,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonColor: themeConfig.appPrimaryColor,
          confirmButtonText: this.$t('frontend_close'),
        });
      } else if (
        this.input_currentTab === 'textbox' ||
        this.input_currentTab === 'datepicker' ||
        this.input_currentTab === 'textarea'
      ) {
        this.$v.model.identifier.$touch();
        this.$v.model.fieldtext.$touch();
        if (
          !this.$v.model.identifier.$invalid &&
          !this.$v.model.fieldtext.$invalid
        ) {
          this.$emit('showLoader');
          const customfield = new Customfield({});
          customfield.identifier = this.model.identifier;
          customfield.type = this.input_currentTab;
          customfield.fieldplaceholder = this.model.fieldtext;
          customfield.mandatory = this.model.mandatory;
          customfield.icon = this.model.icon;
          customfield.default = this.model.defaultValue;
          const customFieldRes = await customfield.save();
          this.$emit('closeCreateFieldModal', customFieldRes);
          this.initalizeAllFields();
          this.$emit('hideLoader');
          this.$emit('fetchfields');
        }
      } else {
        this.$v.model.identifier.$touch();
        this.$v.model.fieldlabel.$touch();
        if (
          !this.$v.model.identifier.$invalid &&
          !this.$v.model.fieldlabel.$invalid &&
          ((this.model.mandatory && this.model.fieldoptions.length) ||
            !this.model.mandatory)
        ) {
          this.$emit('showLoader');
          const customfield = new Customfield({});
          customfield.identifier = this.model.identifier;
          customfield.type = this.input_currentTab;
          customfield.fieldlabel = this.model.fieldlabel;
          customfield.fieldoptions = JSON.stringify(this.model.fieldoptions);
          customfield.mandatory = this.model.mandatory;
          customfield.default = this.model.defaultValue;
          const customFieldRes = await customfield.save();
          this.$emit('closeCreateFieldModal', customFieldRes);
          this.initalizeAllFields();
          this.$emit('hideLoader');
          this.$emit('fetchfields');
        }
      }
    },

    // edit custom field function
    async updateCustomField() {
      this.customFieldFormSubmitted = true;

      // check if identifier is valid
      if (this.identifierInValid) {
        return true;
      }

      this.$v.model.identifier.$touch();
      this.$v.model.fieldtext.$touch();
      
      if (
        (this.input_currentTab === 'textbox' || this.input_currentTab === 'datepicker' || this.input_currentTab === 'textarea') && 
        !this.$v.model.identifier.$invalid && !this.$v.model.fieldtext.$invalid
        ) {
          this.$emit('showLoader');
          this.customfieldData.identifier = this.model.identifier;
          this.customfieldData.type = this.input_currentTab;
          this.customfieldData.mandatory = this.model.mandatory;
          this.customfieldData.default = this.model.defaultValue;
          
          this.customfieldData.fieldplaceholder = this.model.fieldtext;
          this.customfieldData.icon = this.model.icon;
      } else if (
          !this.$v.model.identifier.$invalid && !this.$v.model.fieldlabel.$invalid && 
          ((this.model.mandatory && this.model.fieldoptions.length) || !this.model.mandatory)
          ) {
            this.$emit('showLoader');
            this.customfieldData.identifier = this.model.identifier;
            this.customfieldData.type = this.input_currentTab;
            this.customfieldData.mandatory = this.model.mandatory;
            this.customfieldData.default = this.model.defaultValue;
            
            this.customfieldData.fieldlabel = this.model.fieldlabel;
            this.customfieldData.fieldoptions = JSON.stringify(this.model.fieldoptions);
        }
        
        // update custom field
        await this.customfieldData.customfieldUpdate(this.customfieldData);
        
        // close modal and refresh data table
        this.$emit('closeEditFieldModal');

        // reset form fields
        this.$emit('hideLoader');
        this.initalizeAllFields();
        this.$emit('fetchfields');
    },
  },

  validations: {
    model: {
      identifier: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      fieldtext: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(150),
      },
      fieldlabel: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(150),
      },
    },
  },

  created() {
    if (this.type === 'add' && !this.customfieldData) {
      this.initalizeAllFields();
      this.input_currentTab = 'dropdown';
    } else if (this.type === 'edit' && this.customfieldData) {
      this.model.identifier = this.customfieldData.identifier;
      this.input_currentTab = this.customfieldData.type;
      this.model.fieldlabel = this.customfieldData.fieldlabel;
      this.model.mandatory = this.customfieldData.mandatory;
      this.model.defaultValue = this.customfieldData.default ? this.customfieldData.default : '';
      this.model.fieldtext = this.customfieldData.fieldplaceholder;
      this.model.icon = this.customfieldData.icon;
      if (this.customfieldData.fieldoptions) {
        this.model.fieldoptions =
          this.customfieldData.fieldoptions !== '' ||
          this.customfieldData.fieldoptions != null
            ? JSON.parse(this.customfieldData.fieldoptions)
            : [];
      } else {
        this.model.fieldoptions = [];
      }
    }
  },

  components: {
    FontAwesomePicker,
    VuePerfectScrollbar,
    Treeselect,
    InfoIcon,
    DeleteIcon,
  },

  watch: {
    'model.identifier': function identiFierWatcher(newVal) {
      this.model.identifier = this.model.identifier.toLowerCase();
      if (typeof newVal === 'undefined' || newVal === null || newVal === '') {
        this.identifierInValid = false;
      } else if (newVal && newVal.length >= 3) {
        this.identifierInValid = !/^[a-zA-Z_]*$/.test(newVal);
      }
    },

    input_currentTab(newVal) {
      if (newVal === 'textarea' || newVal === 'textbox' || newVal === 'datepicker') {
        this.model.fieldoptions = [];
      }
    },
  },

  computed: {
    customFieldOptions() {
      return [
        {
          id: 'dropdown',
          label: this.$t(
            'frontend_groovemail_forms_form_creation_dropdown_option'
          ),
        },
        {
          id: 'radio',
          label: this.$t(
            'frontend_groovemail_forms_form_creation_radio_option'
          ),
        },
        {
          id: 'checkbox',
          label: this.$t(
            'frontend_groovemail_forms_form_creation_checkbox_option'
          ),
        },
        {
          id: 'textbox',
          label: this.$t(
            'frontend_groovemail_forms_form_creation_input_option'
          ),
        },
        {
          id: 'textarea',
          label: this.$t(
            'frontend_groovemail_forms_form_creation_textarea_option'
          ),
        },
        {
          id: 'datepicker',
          label: 'Date Picker',
        },
      ];
    },

    admin() {
      return this.$store.state.user.admin;
    },
  },
};
</script>

<style scoped>
.gm-custom-field-editor {
  min-width: 0;
  color: var(--gs-foreground);
}

.gm-custom-field-editor__body {
  min-width: 0;
}

@media (max-width: 640px) {
  .gm-custom-field-editor__body > .p-6 {
    padding: 20px 18px;
  }
}
</style>
